if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        if (this.classList.contains('modal-pdp__gallery')) {
          this.classList.remove('modal-pdp__gallery--fullscreen');
          const scrollY = document.body.style.top ? Math.abs(parseInt(document.body.style.top, 10)) : 0;
          document.body.classList.remove('modal-pdp-open');
          document.body.style.top = '';
          window.scrollTo(0, scrollY);
        }
        super.hide();
      }

      isHeaderVisible() {
        if (!window.matchMedia('(min-width: 750px)').matches) return false;
        const header = document.querySelector('.section-header');
        if (!header) return false;
        const rect = header.getBoundingClientRect();
        return rect.bottom > 0;
      }

      show(opener) {
        super.show(opener);
        if (this.classList.contains('modal-pdp__gallery')) {
          document.body.style.top = `-${window.scrollY}px`;
          document.body.classList.add('modal-pdp-open');
          if (this.isHeaderVisible()) {
            this.classList.remove('modal-pdp__gallery--fullscreen');
          } else {
            this.classList.add('modal-pdp__gallery--fullscreen');
          }
        }
        this.showActiveMedia();
        if (this.isModalPdpGallery()) {
          this.initModalPdpScrollSpy();
        }
      }

      isModalPdpGallery() {
        return this.classList.contains('modal-pdp__gallery');
      }

      updateModalPdpStageLayout() {
        if (!this.isModalPdpGallery()) return;
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        content.querySelectorAll('.modal-pdp__stage').forEach((stage) => {
          stage.classList.remove('modal-pdp__stage--tall');
        });
      }

      scrollModalPdpStageIntoView(mediaId, behavior) {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        const stage = content.querySelector(`.modal-pdp__stage[data-media-id="${mediaId}"]`);
        if (!stage) return;
        this._modalPdpProgrammaticScroll = true;
        stage.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
        window.setTimeout(() => {
          this._modalPdpProgrammaticScroll = false;
        }, behavior === 'auto' ? 50 : 700);
      }

      initModalPdpScrollSpy() {
        if (!this.isModalPdpGallery() || this._modalPdpScrollSpyInit) return;
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        this._modalPdpScrollSpyInit = true;

        const syncActiveFromScroll = () => {
          if (this._modalPdpProgrammaticScroll) return;
          const stages = content.querySelectorAll('.modal-pdp__stage');
          const rootRect = content.getBoundingClientRect();
          const mid = rootRect.top + rootRect.height * 0.35;
          let bestId = null;
          let bestDist = Infinity;
          stages.forEach((stage) => {
            const rect = stage.getBoundingClientRect();
            if (rect.bottom < rootRect.top || rect.top > rootRect.bottom) return;
            const dist = Math.abs(rect.top - mid);
            if (dist < bestDist) {
              bestDist = dist;
              bestId = stage.getAttribute('data-media-id');
            }
          });
          if (!bestId) return;
          const active = content.querySelector('.modal-pdp__stage.active');
          if (active && active.getAttribute('data-media-id') === bestId) return;
          this.setActiveMediaByMediaId(bestId, { scroll: false });
        };

        let scrollTimer;
        content.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(scrollTimer);
            scrollTimer = window.setTimeout(syncActiveFromScroll, 80);
          },
          { passive: true }
        );
      }

      setModalPdpActiveMedia(content, mediaId, addOnly) {
        content.querySelectorAll('.modal-pdp__stage').forEach((el) => {
          const isMatch = el.getAttribute('data-media-id') === String(mediaId);
          if (addOnly) {
            if (isMatch) el.classList.add('active');
          } else {
            el.classList.toggle('active', isMatch);
          }
        });
      }

      getActiveMediaElement(content, mediaId) {
        if (this.isModalPdpGallery()) {
          const stage = content.querySelector(`.modal-pdp__stage[data-media-id="${mediaId}"]`);
          if (!stage) return null;
          return (
            stage.querySelector('deferred-media') ||
            stage.querySelector('.product-media-modal__model') ||
            stage.querySelector('img') ||
            stage
          );
        }
        return content.querySelector(`[data-media-id="${mediaId}"]`);
      }

      playActiveModalMedia(activeMedia) {
        if (!activeMedia) return;
        const slide =
          activeMedia.closest('.modal-pdp__stage') ||
          activeMedia.closest('[data-media-id]') ||
          activeMedia;
        if (typeof playDeferredMediaInSlide === 'function') {
          playDeferredMediaInSlide(slide);
        }
      }

      updateMobileNav() {
        const thumbs = this.querySelectorAll('.product-media-modal__thumb');
        const content = this.querySelector('.product-media-modal__content');
        if (!thumbs.length || !content) return;
        const activeEl =
          content.querySelector('.modal-pdp__stage.active') || content.querySelector('[data-media-id].active');
        const activeId = activeEl && activeEl.getAttribute('data-media-id');
        const ids = Array.from(thumbs).map((t) => t.getAttribute('data-media-id'));
        const index = activeId ? ids.indexOf(activeId) : 0;
        const current = index >= 0 ? index + 1 : 1;
        const totalEl = this.querySelector('.modal-pdp__nav-total');
        const currentEl = this.querySelector('.modal-pdp__nav-current');
        if (totalEl) totalEl.textContent = ids.length;
        if (currentEl) currentEl.textContent = current;
      }

      setActiveMediaByMediaId(mediaId, options) {
        if (!mediaId) return;
        const opts = options && typeof options === 'object' ? options : {};
        const shouldScroll = opts.scroll !== false;
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        if (this.isModalPdpGallery()) {
          this.setModalPdpActiveMedia(content, mediaId, false);
        } else {
          content.querySelectorAll('[data-media-id]').forEach((el) => {
            el.classList.toggle('active', el.getAttribute('data-media-id') === String(mediaId));
          });
        }
        const activeMedia = this.getActiveMediaElement(content, mediaId);
        if (!activeMedia) return;

        this.playActiveModalMedia(activeMedia);

        if (this.isModalPdpGallery()) {
          this.updateModalPdpStageLayout();
          if (shouldScroll) {
            this.scrollModalPdpStageIntoView(mediaId, opts.behavior || 'smooth');
          }
        } else {
          const container = this.querySelector('[role="document"]');
          if (container && activeMedia.scrollIntoView) {
            activeMedia.scrollIntoView();
          }
          if (container && typeof activeMedia.width !== 'undefined') {
            container.scrollLeft = Math.max(0, (activeMedia.width - container.clientWidth) / 2);
          }
        }

        const thumbs = this.querySelectorAll('.product-media-modal__thumb');
        thumbs.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
          if (thumb.getAttribute('data-media-id') === String(mediaId)) {
            thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
        this.updateMobileNav();
      }

      showActiveMedia() {
        const mediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        if (this.isModalPdpGallery()) {
          content.querySelectorAll('.modal-pdp__stage').forEach((el) => el.classList.remove('active'));
          this.setModalPdpActiveMedia(content, mediaId, true);
        } else {
          content.querySelectorAll('[data-media-id]').forEach((el) => {
            el.classList.remove('active');
          });
        }
        const activeMedia = this.getActiveMediaElement(content, mediaId);
        if (!activeMedia) return;

        if (!this.isModalPdpGallery()) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          if (container && typeof activeMedia.width !== 'undefined') {
            container.scrollLeft = Math.max(0, (activeMedia.width - container.clientWidth) / 2);
          }
        }

        this.playActiveModalMedia(activeMedia);

        if (this.isModalPdpGallery()) {
          this.updateModalPdpStageLayout();
          this.initModalPdpScrollSpy();
          requestAnimationFrame(() => {
            this.scrollModalPdpStageIntoView(mediaId, 'auto');
          });
        }

        const thumbs = this.querySelectorAll('.product-media-modal__thumb');
        thumbs.forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId);
          if (thumb.getAttribute('data-media-id') === mediaId) {
            thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
        this.updateMobileNav();
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.modal-pdp__nav-prev, .modal-pdp__nav-next');
    if (!btn) return;
    const modal = btn.closest('product-modal');
    if (!modal || !modal.setActiveMediaByMediaId) return;
    const thumbs = modal.querySelectorAll('.product-media-modal__thumb');
    const content = modal.querySelector('.product-media-modal__content');
    if (!thumbs.length || !content) return;
    const activeEl =
      content.querySelector('.modal-pdp__stage.active') || content.querySelector('[data-media-id].active');
    const activeId = activeEl ? activeEl.getAttribute('data-media-id') : null;
    const ids = Array.from(thumbs).map((t) => t.getAttribute('data-media-id'));
    const index = activeId ? ids.indexOf(activeId) : 0;
    const dir = btn.classList.contains('modal-pdp__nav-next') ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(ids.length - 1, index + dir));
    modal.setActiveMediaByMediaId(ids[nextIndex]);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    const opener = e.target.closest('.product__modal-opener--image');
    if (!opener) return;
    const button = opener.querySelector('button[data-media-id]');
    if (!button) return;
    if (e.target.closest('button')) return;
    const modal = document.querySelector(opener.getAttribute('data-modal'));
    if (!modal || !modal.classList.contains('product-media-modal')) return;
    e.preventDefault();
    e.stopPropagation();
    modal.show(button);
  }, true);
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.product-media-modal__thumb');
    if (!thumb) return;
    e.preventDefault();
    const modal = thumb.closest('product-modal');
    if (!modal || !modal.setActiveMediaByMediaId) return;
    modal.setActiveMediaByMediaId(thumb.getAttribute('data-media-id'));
  });
});

(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  function initThumbnailsTouchScroll(modal) {
    const thumbsEl = modal && modal.querySelector('.modal-pdp__thumbnails');
    if (!thumbsEl || thumbsEl.dataset.touchScrollInit) return;
    thumbsEl.dataset.touchScrollInit = '1';

    let startY = 0;
    let startScrollTop = 0;

    thumbsEl.addEventListener(
      'touchstart',
      function (e) {
        startY = e.touches[0].clientY;
        startScrollTop = thumbsEl.scrollTop;
      },
      { passive: true }
    );

    thumbsEl.addEventListener(
      'touchmove',
      function (e) {
        const maxScroll = thumbsEl.scrollHeight - thumbsEl.clientHeight;
        if (maxScroll <= 0) return;
        const y = e.touches[0].clientY;
        const delta = startY - y;
        const next = startScrollTop + delta;
        thumbsEl.scrollTop = Math.max(0, Math.min(maxScroll, next));
        startY = y;
        startScrollTop = thumbsEl.scrollTop;
        e.preventDefault();
      },
      { passive: false, capture: true }
    );
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type !== 'attributes' || m.attributeName !== 'open') return;
      const modal = m.target;
      if (modal.classList.contains('modal-pdp__gallery') && modal.hasAttribute('open')) {
        initThumbnailsTouchScroll(modal);
      }
    });
  });

  document.querySelectorAll('.modal-pdp__gallery').forEach(function (modal) {
    initThumbnailsTouchScroll(modal);
    observer.observe(modal, { attributes: true });
  });
})();

(function () {
  function goToAdjacentMedia(modal, direction) {
    if (!modal || !modal.setActiveMediaByMediaId) return;
    const thumbs = modal.querySelectorAll('.product-media-modal__thumb');
    const content = modal.querySelector('.product-media-modal__content');
    if (!thumbs.length || !content) return;
    const activeEl =
      content.querySelector('.modal-pdp__stage.active') || content.querySelector('[data-media-id].active');
    const activeId = activeEl ? activeEl.getAttribute('data-media-id') : null;
    const ids = Array.from(thumbs).map((t) => t.getAttribute('data-media-id'));
    const index = activeId ? ids.indexOf(activeId) : 0;
    const nextIndex = Math.max(0, Math.min(ids.length - 1, index + direction));
    if (nextIndex !== index) modal.setActiveMediaByMediaId(ids[nextIndex]);
  }

  function initScrollToChangeImage(modal) {
    const content = modal && modal.querySelector('.modal-pdp__content');
    if (!content || content.dataset.scrollChangeInit) return;
    content.dataset.scrollChangeInit = '1';
    if (modal.initModalPdpScrollSpy) modal.initModalPdpScrollSpy();
  }

  function initAllScrollToChange() {
    document.querySelectorAll('.modal-pdp__gallery').forEach(initScrollToChangeImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScrollToChange);
  } else {
    initAllScrollToChange();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type !== 'attributes' || m.attributeName !== 'open') return;
      const modal = m.target;
      if (modal.classList.contains('modal-pdp__gallery') && modal.hasAttribute('open')) {
        initScrollToChangeImage(modal);
      }
    });
  });
  document.querySelectorAll('.modal-pdp__gallery').forEach(function (modal) {
    observer.observe(modal, { attributes: true });
  });
})();
